import {
  AssertionData,
  WebAuthnResponse,
} from '@/init/ibowClient/services/WebAuthnService';

const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  const binary = String.fromCharCode(...new Uint8Array(buffer));
  return window
    .btoa(binary)
    .replace(/\//g, '_')
    .replace(/\+/g, '-')
    .replace(/=+$/g, '');
};

const base64StringToArrayBuffer = (base64String: string) => {
  const replaced = base64String.replace(/_/g, '/').replace(/-/g, '+');
  const decoded = window.atob(replaced);
  return Uint8Array.from(decoded, (c) => c.charCodeAt(0));
};

/**
 * サーバーから受け取った生体認証の情報を整形する
 */
export function formatPublicKeyCredentialRequestOptions(
  webauthnResponse: WebAuthnResponse,
): PublicKeyCredentialRequestOptions {
  return {
    ...webauthnResponse,
    challenge: base64StringToArrayBuffer(webauthnResponse.challenge),
    allowCredentials: webauthnResponse.allowCredentials.map((credential) => ({
      ...credential,
      id: base64StringToArrayBuffer(credential.id),
    })),
  };
}

/**
 * デバイスで認証した結果を整形する
 */
export function formatPublicKeyCredential(
  credential: Credential,
): AssertionData {
  if (!credential || !(credential instanceof PublicKeyCredential)) {
    throw new Error('Invalid credential');
  }

  const assertion: AssertionData = {
    id: credential.id,
    type: credential.type,
    rawId: arrayBufferToBase64(credential.rawId),
    response: {
      authenticatorData: '',
      clientDataJSON: '',
      signature: '',
      userHandle: '',
    },
  };

  if (
    credential.response &&
    credential.response instanceof AuthenticatorAssertionResponse
  ) {
    const clientDataJSON = arrayBufferToBase64(
      credential.response.clientDataJSON,
    );
    const authenticatorData = arrayBufferToBase64(
      credential.response.authenticatorData,
    );
    const signature = arrayBufferToBase64(credential.response.signature);
    const userHandle = credential.response.userHandle
      ? arrayBufferToBase64(credential.response.userHandle)
      : '';
    assertion.response = {
      clientDataJSON,
      authenticatorData,
      signature,
      userHandle,
    };
  }

  return assertion;
}
